module.exports = __webpack_public_path__ + "img/android-frame.2d74699.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/android-frame.png
// module id = pPg1
// module chunks = 38 43